import FJTextEditStore from '../../../store/FJTextBaseEditing/FJTextEditStore.js';
import { setEditFloatingPanelVisible } from '../../slices/FJSliceTextEditFloatingPanel.js';
import FJActionRightTextBaseEditing from './FJActionRightTextBaseEditing.js';
import FJActionTextBasedEditingExtension from './FJActionTextBasedEditingExtension.js';
import FJActionTextBasedEditing from './FJActionTextBasedEditing.js';
import FJStore from '../../FJStore.js';

let _mousePoint = null;
let _isMouseDown = false;

const _convertPointPageToEditPreview = (editTextPreviewId, point) => {
    const div = document.getElementById(editTextPreviewId);
    if (!div) return point;
    const scrollerRect = FJTextEditStore.getTextEditPreviewBoxRect(editTextPreviewId);
    return { x: point.x - scrollerRect.x, y: point.y - scrollerRect.y + div.scrollTop };
};

const _mouseDown = point => {
    _mousePoint = point;
    _isMouseDown = true;
    FJTextEditStore.selectAtPoint(point);
    document.addEventListener('mouseup', _mouseUp);
};

const _mouseMove = point => {
    if (!_mousePoint || !_isMouseDown) return;

    const startPoint = point.y > _mousePoint.y ? _mousePoint : point;
    const endPoint = point.y > _mousePoint.y ? point : _mousePoint;

    const minX = Math.min(point.x, _mousePoint.x);
    const minY = Math.min(point.y, _mousePoint.y);
    const width = Math.abs(point.x - _mousePoint.x);
    const height = Math.abs(point.y - _mousePoint.y);

    FJTextEditStore.selectInRect({ x: minX, y: minY, width, height }, startPoint, endPoint);
};

const _doubleClick = point => {
    FJTextEditStore.selectLineAtPoint(point);
};

const _mouseUp = () => {
    _mousePoint = null;
    _isMouseDown = false;
    document.removeEventListener('mouseup', _mouseUp);
    FJStore.dispatch(FJActionTextBasedEditingMouseEvent.updateAfterMouseUp());
};

const FJActionTextBasedEditingMouseEvent = {
    onMouseEventAction: (eventType, point) => {
        return (dispatch, getState) => {
            const editTextPreviewId = getState().textBasedEditing.editTextPreviewId;
            const p = _convertPointPageToEditPreview(editTextPreviewId, point);
            switch (eventType) {
                case 'mouseDown': {
                    _mouseDown(p);
                    dispatch(setEditFloatingPanelVisible(false));
                    break;
                }
                case 'doubleClick':
                    _doubleClick(p);
                    break;
                case 'mouseMove':
                    _mouseMove(p);
                    break;
                case 'wheel':
                    dispatch(setEditFloatingPanelVisible(false));
                    break;
                default:
                    break;
            }
        };
    },
    updateAfterMouseUp: () => {
        return dispatch => {
            //浮动面板
            dispatch(FJActionTextBasedEditingExtension.updateFloatingPanelAction());
            // 预览页面的时间线的选中
            dispatch(FJActionRightTextBaseEditing.updateSelectedTimesAction());

            dispatch(FJActionTextBasedEditing.updateSearchMatchIndexAction());
        };
    },
};

export default FJActionTextBasedEditingMouseEvent;
